<script lang="ts">
import { defineComponent } from 'vue'
export default defineComponent({
  name: "HText",
  
})
</script>
<template>
  <span>
    <template v-if="modelValue !== 'HTEXT_DEFAULT_VALUE'">
      <span v-if="!!modelValue || modelValue === 0">{{modelValue}}</span>
      <span v-else>--</span>
    </template>
  </span>
</template>

<script lang="ts" setup name="HText">
  import {defineProps, withDefaults} from "vue";
  interface Props {
    modelValue: any;
  }
  withDefaults(defineProps<Props>(), {
    modelValue: "HTEXT_DEFAULT_VALUE"
  });
</script>

<style scoped>

</style>
